import filter from "lodash-es/filter"
import isEmpty from "lodash-es/isEmpty"

import { type TButtonProps } from "@/3514/components"
import { EUserRole } from "@/3514/types"

import renderers from "./session-info.renderers.buttons"
import type {
    _TSessionInfoRenderFunctionSharedExternalParams as TRenderButtonPropsFunctionExternalParams,
    _TSessionInfoRenderButtonPropsFunctionInternalParams as TRenderButtonPropsFunctionInternalParams
} from "./session-info.types"

function participantProps(
    internal: TRenderButtonPropsFunctionInternalParams,
    external: TRenderButtonPropsFunctionExternalParams
): TButtonProps[] {
    return filter<TButtonProps>(
        [
            Boolean(internal.sessionTimeState.isUpcoming || internal.sessionTimeState.isLive) &&
                renderers.renderJoinButtonProps({ ...internal, ...external })
        ],
        Boolean
    )
}

function coachProps(
    internal: TRenderButtonPropsFunctionInternalParams,
    external: TRenderButtonPropsFunctionExternalParams
): TButtonProps[] {
    return filter<TButtonProps>(
        [
            renderers.renderAttendanceButtonProps({ ...internal, ...external }),

            Boolean(internal.sessionTimeState.isUpcoming && !isEmpty(internal.data.session.joinUrl)) &&
                renderers.renderJoinButtonProps({ ...internal, ...external })
        ],
        Boolean
    )
}

export default {
    [EUserRole.Participant]: participantProps,
    [EUserRole.Assistant]: participantProps,
    [EUserRole.Coach]: coachProps,
    [EUserRole.Manager]: coachProps
}
